import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Terminal, Lock, Send, CheckCircle2 } from 'lucide-react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <section id="contact" className="py-24 bg-brand-dark relative" data-id="element-12">
      <div className="container mx-auto px-6" data-id="element-13">
        <div className="max-w-4xl mx-auto" data-id="element-14">
          <div className="text-center mb-12" data-id="element-15">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-mono font-bold text-white mb-4" data-id="element-16">
              Initiate Secure Contact
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-slate-400 text-lg flex items-center justify-center gap-2" data-id="element-17">
              <Lock className="w-4 h-4 text-brand-steel" data-id="element-18" />
              All communications are end-to-end encrypted
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#0c111a] rounded-xl border border-brand-border overflow-hidden shadow-[0_0_50px_rgba(74,144,217,0.05)]" data-id="element-19">
            {/* Terminal Header */}
            <div className="bg-[#111827] px-4 py-3 border-b border-brand-border flex items-center gap-2" data-id="element-20">
              <div className="flex gap-1.5" data-id="element-21">
                <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50" data-id="element-22" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50" data-id="element-23" />
                <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50" data-id="element-24" />
              </div>
              <div className="mx-auto flex items-center gap-2 text-xs font-mono text-slate-500" data-id="element-25">
                <Terminal className="w-3 h-3" data-id="element-26" />
                epicdrop_secure_channel.sh
              </div>
            </div>

            {/* Form Body */}
            <div className="p-8 md:p-10" data-id="element-27">
              {isSuccess ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="flex flex-col items-center justify-center py-12 text-center" data-id="element-28">
                  <div className="w-16 h-16 bg-brand-steel/10 rounded-full flex items-center justify-center mb-6" data-id="element-29">
                    <CheckCircle2 className="w-8 h-8 text-brand-steel" data-id="element-30" />
                  </div>
                  <h3 className="text-2xl font-mono font-bold text-white mb-2" data-id="element-31">
                    Transmission Secured
                  </h3>
                  <p className="text-slate-400 max-w-md" data-id="element-32">
                    Your briefing request has been encrypted and routed to our
                    operatives. We will establish contact shortly.
                  </p>
                  <button onClick={() => setIsSuccess(false)} className="mt-8 text-sm font-mono text-brand-cyan hover:text-white transition-colors" data-id="element-33">
                    &gt; Initiate another transmission
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-34">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-35">
                    <div className="space-y-2" data-id="element-36">
                      <label className="text-xs font-mono text-brand-cyan uppercase tracking-wider" data-id="element-37">
                        Full Name
                      </label>
                      <input required type="text" className="w-full bg-brand-dark border border-brand-border rounded-md px-4 py-3 text-white focus:outline-none focus:border-brand-steel focus:ring-1 focus:ring-brand-steel transition-all font-sans" placeholder="John Doe" data-id="element-38" />
                    </div>
                    <div className="space-y-2" data-id="element-39">
                      <label className="text-xs font-mono text-brand-cyan uppercase tracking-wider" data-id="element-40">
                        Business Email
                      </label>
                      <input required type="email" className="w-full bg-brand-dark border border-brand-border rounded-md px-4 py-3 text-white focus:outline-none focus:border-brand-steel focus:ring-1 focus:ring-brand-steel transition-all font-sans" placeholder="j.doe@company.com" data-id="element-41" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-42">
                    <div className="space-y-2" data-id="element-43">
                      <label className="text-xs font-mono text-brand-cyan uppercase tracking-wider" data-id="element-44">
                        Company Name
                      </label>
                      <input required type="text" className="w-full bg-brand-dark border border-brand-border rounded-md px-4 py-3 text-white focus:outline-none focus:border-brand-steel focus:ring-1 focus:ring-brand-steel transition-all font-sans" placeholder="Acme Corp" data-id="element-45" />
                    </div>
                    <div className="space-y-2" data-id="element-46">
                      <label className="text-xs font-mono text-brand-cyan uppercase tracking-wider" data-id="element-47">
                        Employees
                      </label>
                      <select required className="w-full bg-brand-dark border border-brand-border rounded-md px-4 py-3 text-white focus:outline-none focus:border-brand-steel focus:ring-1 focus:ring-brand-steel transition-all font-sans appearance-none" data-id="element-48">
                        <option value="" disabled selected data-id="element-49">
                          Select size...
                        </option>
                        <option value="1-50" data-id="element-50">1 - 50</option>
                        <option value="51-200" data-id="element-51">51 - 200</option>
                        <option value="201-500" data-id="element-52">201 - 500</option>
                        <option value="500+" data-id="element-53">500+</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-54">
                    <label className="text-xs font-mono text-brand-cyan uppercase tracking-wider" data-id="element-55">
                      Message / Current Stack
                    </label>
                    <textarea required rows={4} className="w-full bg-brand-dark border border-brand-border rounded-md px-4 py-3 text-white focus:outline-none focus:border-brand-steel focus:ring-1 focus:ring-brand-steel transition-all font-sans resize-none" placeholder="Describe your current security infrastructure and primary concerns..." data-id="element-56" />
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-brand-steel hover:bg-brand-steel-light text-white font-mono font-bold rounded-md transition-all flex items-center justify-center gap-2 shadow-[0_0_15px_rgba(74,144,217,0.2)] hover:shadow-[0_0_25px_rgba(74,144,217,0.4)] disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-57">
                    {isSubmitting ? <span className="flex items-center gap-2" data-id="element-58">
                        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-59" />
                        Encrypting...
                      </span> : <span className="flex items-center gap-2" data-id="element-60">
                        <Send className="w-4 h-4" data-id="element-61" />
                        Request Encrypted Briefing
                      </span>}
                  </button>
                </form>}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}